export const ROOT = 'ROOT'
export const PLAY = 'PLAY'

export const routes = {
  [ROOT]: '/',
  [PLAY]: '/play',
}